var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"btn btn-primary",class:{ 'btn-lg': !_vm.inline, 'w-100': !_vm.inline, 'rounded-pill' : _vm.pill, 'float-right': _vm.floatRight },attrs:{"type":_vm.type,"disabled":_vm.disabled||_vm.loading}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }